import { actionKey } from './constants';
import { createAction } from 'redux-actions';
export const logPageView = createAction(`${actionKey}/LOG_PAGEVIEW`, (payload)=>payload);
